var _path, _g, _g2;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";

const SvgFlagOnline = ({
  svgRef,
  title,
  ...props
}) => /*#__PURE__*/React.createElement("svg", _extends({
  id: "Layer_1",
  x: "0px",
  y: "0px",
  viewBox: "0 0 37.8 22.6",
  style: {
    enableBackground: "new 0 0 37.8 22.6"
  },
  xmlSpace: "preserve",
  ref: svgRef
}, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
  className: "st0",
  d: "M0,0l37.8,22.2V4c0-2.2-1.8-4-4-4H0z"
})), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
  className: "st1",
  d: "M25.9,6.2h-0.5v-2c0-0.2,0-0.4,0-0.6c0,0-0.1,0.1-0.1,0.1c0,0-0.2,0.2-0.5,0.4l-0.2-0.3l0.9-0.7h0.4V6.2z"
}), /*#__PURE__*/React.createElement("path", {
  className: "st1",
  d: "M29,4.7c0,0.5-0.1,0.9-0.3,1.2c-0.2,0.3-0.4,0.4-0.8,0.4c-0.3,0-0.6-0.1-0.8-0.4s-0.3-0.7-0.3-1.2 c0-0.5,0.1-0.9,0.3-1.2c0.2-0.3,0.4-0.4,0.8-0.4c0.3,0,0.6,0.1,0.8,0.4C28.9,3.8,29,4.1,29,4.7z M27.4,4.7c0,0.4,0,0.7,0.1,0.9 c0.1,0.2,0.2,0.3,0.4,0.3c0.2,0,0.3-0.1,0.4-0.3c0.1-0.2,0.1-0.5,0.1-0.9c0-0.4,0-0.7-0.1-0.9c-0.1-0.2-0.2-0.3-0.4-0.3 c-0.2,0-0.3,0.1-0.4,0.3C27.4,3.9,27.4,4.2,27.4,4.7z"
}), /*#__PURE__*/React.createElement("path", {
  className: "st1",
  d: "M31.4,4.7c0,0.5-0.1,0.9-0.3,1.2c-0.2,0.3-0.4,0.4-0.8,0.4c-0.3,0-0.6-0.1-0.8-0.4c-0.2-0.3-0.3-0.7-0.3-1.2 c0-0.5,0.1-0.9,0.3-1.2c0.2-0.3,0.4-0.4,0.8-0.4c0.3,0,0.6,0.1,0.8,0.4C31.3,3.8,31.4,4.1,31.4,4.7z M29.8,4.7c0,0.4,0,0.7,0.1,0.9 c0.1,0.2,0.2,0.3,0.4,0.3s0.3-0.1,0.4-0.3c0.1-0.2,0.1-0.5,0.1-0.9c0-0.4,0-0.7-0.1-0.9c-0.1-0.2-0.2-0.3-0.4-0.3S30,3.6,29.9,3.8 C29.9,3.9,29.8,4.2,29.8,4.7z"
}), /*#__PURE__*/React.createElement("path", {
  className: "st1",
  d: "M33.1,4c0,0.3-0.1,0.6-0.2,0.7C32.8,4.9,32.6,5,32.4,5c-0.2,0-0.4-0.1-0.5-0.2c-0.1-0.2-0.2-0.4-0.2-0.7 c0-0.6,0.2-0.9,0.7-0.9c0.2,0,0.4,0.1,0.5,0.2C33,3.5,33.1,3.7,33.1,4z M32.1,4c0,0.2,0,0.4,0.1,0.5c0,0.1,0.1,0.2,0.2,0.2 c0.2,0,0.3-0.2,0.3-0.6c0-0.4-0.1-0.6-0.3-0.6c-0.1,0-0.2,0.1-0.2,0.2C32.2,3.7,32.1,3.8,32.1,4z M34.4,3.1l-1.7,3h-0.4l1.7-3H34.4 z M35,5.3C35,5.6,35,5.8,34.9,6s-0.3,0.2-0.5,0.2c-0.2,0-0.4-0.1-0.5-0.2c-0.1-0.2-0.2-0.4-0.2-0.7c0-0.6,0.2-0.9,0.7-0.9 c0.2,0,0.4,0.1,0.5,0.2C35,4.7,35,5,35,5.3z M34.1,5.3c0,0.2,0,0.4,0.1,0.5c0,0.1,0.1,0.2,0.2,0.2c0.2,0,0.3-0.2,0.3-0.6 c0-0.4-0.1-0.6-0.3-0.6c-0.1,0-0.2,0-0.2,0.1C34.1,4.9,34.1,5.1,34.1,5.3z"
}))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
  className: "st1",
  d: "M26.1,8.9c0,0.3-0.1,0.6-0.3,0.8c-0.2,0.2-0.4,0.3-0.7,0.3c-0.2,0-0.4,0-0.5-0.1c-0.1-0.1-0.3-0.2-0.3-0.4 c-0.1-0.2-0.1-0.4-0.1-0.6c0-0.3,0.1-0.6,0.3-0.8c0.2-0.2,0.4-0.3,0.7-0.3c0.3,0,0.5,0.1,0.7,0.3S26.1,8.6,26.1,8.9z M24.6,8.9 c0,0.5,0.2,0.7,0.5,0.7c0.4,0,0.5-0.2,0.5-0.7c0-0.5-0.2-0.7-0.5-0.7c-0.2,0-0.3,0.1-0.4,0.2C24.6,8.5,24.6,8.7,24.6,8.9z"
}), /*#__PURE__*/React.createElement("path", {
  className: "st1",
  d: "M28.4,10H28V8.7c0-0.2,0-0.3-0.1-0.4c-0.1-0.1-0.2-0.1-0.3-0.1c-0.2,0-0.3,0.1-0.4,0.2S27,8.7,27,8.9v1h-0.4 V7.9h0.3L27,8.2h0c0.1-0.1,0.2-0.2,0.3-0.2s0.2-0.1,0.4-0.1c0.5,0,0.7,0.3,0.7,0.8V10z"
}), /*#__PURE__*/React.createElement("path", {
  className: "st1",
  d: "M29.5,10H29V7.1h0.4V10z"
}), /*#__PURE__*/React.createElement("path", {
  className: "st1",
  d: "M30.1,7.4c0-0.1,0-0.1,0.1-0.2c0,0,0.1-0.1,0.2-0.1c0.1,0,0.1,0,0.2,0.1c0,0,0.1,0.1,0.1,0.2 c0,0.1,0,0.1-0.1,0.2c0,0-0.1,0.1-0.2,0.1c-0.1,0-0.1,0-0.2-0.1C30.1,7.5,30.1,7.4,30.1,7.4z M30.6,10h-0.4V7.9h0.4V10z"
}), /*#__PURE__*/React.createElement("path", {
  className: "st1",
  d: "M33,10h-0.4V8.7c0-0.2,0-0.3-0.1-0.4c-0.1-0.1-0.2-0.1-0.3-0.1c-0.2,0-0.3,0.1-0.4,0.2 c-0.1,0.1-0.1,0.3-0.1,0.6v1h-0.4V7.9h0.3l0.1,0.3h0c0.1-0.1,0.2-0.2,0.3-0.2s0.2-0.1,0.4-0.1c0.5,0,0.7,0.3,0.7,0.8V10z"
}), /*#__PURE__*/React.createElement("path", {
  className: "st1",
  d: "M34.5,10c-0.3,0-0.6-0.1-0.8-0.3c-0.2-0.2-0.3-0.4-0.3-0.8c0-0.3,0.1-0.6,0.3-0.8c0.2-0.2,0.4-0.3,0.7-0.3 c0.3,0,0.5,0.1,0.7,0.3s0.2,0.4,0.2,0.7V9H34c0,0.2,0.1,0.4,0.2,0.5c0.1,0.1,0.2,0.2,0.4,0.2c0.1,0,0.2,0,0.3,0 c0.1,0,0.2-0.1,0.3-0.1v0.4C35.1,9.9,35,10,34.9,10C34.8,10,34.7,10,34.5,10z M34.5,8.2c-0.1,0-0.3,0-0.3,0.1C34,8.4,34,8.6,34,8.7 h0.9c0-0.2,0-0.3-0.1-0.4C34.7,8.2,34.6,8.2,34.5,8.2z"
}))));

const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgFlagOnline, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/flag-online.36820af1.svg";
export { ForwardRef as ReactComponent };